import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { useCallback } from 'react';

export default function MirariEchoHero() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.05 });

  /**
   * Smoothly scrolls to the element with the given id.
   * Adds safety checks and error handling to avoid runtime exceptions.
   */
  const scrollToSection = useCallback((id: string) => {
    try {
      const element = document.getElementById(id);
      if (!element) {
        console.warn(`scrollToSection: No element found with id "${id}"`);
        return;
      }
      element.scrollIntoView({ behavior: 'smooth' });
    } catch (error) {
      console.error('scrollToSection: Unexpected error while scrolling', error);
    }
  }, []);

  return (
    <section
      ref={ref}
      className="relative h-screen min-h-[700px] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/2465f97dd6952a06635faf958ad4f625.jpg"
          alt="Echo Installation"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div
        className={`relative z-10 text-center px-8 max-w-5xl mx-auto w-full transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <p className="text-sm uppercase tracking-[0.3em] text-white/70 mb-6">
          Public Space — Interactive Installation
        </p>
        <h1 className="text-6xl lg:text-8xl font-light text-white tracking-wide mb-6">
          Echo
        </h1>
        <div className="w-16 h-px bg-white/40 mx-auto mb-10"></div>
        <div className="max-w-3xl mx-auto mb-14">
          <p className="text-lg text-white/90 leading-relaxed mb-4">
            カナダ・モントリオールのクリエイティブスタジオ mirari との協業により、マルチセンサリー・インタラクティブインスタレーション「Echo」を日本で展開しています。
          </p>
          <p className="text-base text-white/70 leading-relaxed">
            In collaboration with mirari, a creative studio from Montreal, Canada, we bring the multi-sensory interactive installation &quot;Echo&quot; to Japan.
          </p>
        </div>

        <div className="flex items-center justify-center gap-8">
          <button
            onClick={() => scrollToSection('mirari-section')}
            className="px-10 h-14 bg-white text-black text-sm font-medium rounded-full hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap"
          >
            About Mirari
          </button>
          <button
            onClick={() => scrollToSection('echo-section')}
            className="px-10 h-14 bg-transparent text-white text-sm font-medium rounded-full border-2 border-white hover:scale-105 transition-transform duration-300 cursor-pointer whitespace-nowrap"
          >
            About Echo
          </button>
        </div>
      </div>
    </section>
  );
}
